import { Injectable } from '@angular/core';
import type { LeaveType } from '@shared/modules/leave-types/leave-type';
import { Fetcher } from '../../http/fetcher';
import type { CustomFieldsMap } from '@shared/modules/custom-fields-values/custom-field-value';


export interface CreateLeaveTypeRequest {
    is_payable: boolean;
    name: string;
    pay_element_code: string;
    colour?: string;
    custom_fields?: CustomFieldsMap;
}

export interface UpdateLeaveTypeRequest {
    is_payable: boolean;
    name: string;
    pay_element_code: string;
    colour?: string;
    custom_fields?: CustomFieldsMap;
}

@Injectable({
    providedIn: 'root',
})
export class LeaveTypeFetcher extends Fetcher<LeaveType> {
    readonly modelName: string = 'LeaveType';

    get resourceName(): string {
        return 'leave-types';
    }
}
